import React from 'react';
import css from './SeoPage.module.css';

const skeletonStyle = {
  background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.5s infinite',
  borderRadius: '8px',
};

const Skeleton = ({ width, height, className = '', style = {} }) => (
  <div
    className={`skeleton ${className}`}
    style={{
      ...skeletonStyle,
      width,
      height,
      ...style,
    }}
  />
);

// Listing Section Skeleton
export const ListingSectionSkeleton = ({ sectionTitle }) => (
  <section className={css.disciplineSlider}>
    <div className={css.headerRow}>
      {sectionTitle ? (
        <h2 style={{ margin: '0 0 24px 0', fontSize: '20px', fontWeight: 'bold' }}>
          {sectionTitle}
        </h2>
      ) : (
        <Skeleton width="250px" height="28px" style={{ marginBottom: '24px' }} />
      )}
      <div className={css.carouselArrows}>
        <Skeleton width="40px" height="40px" style={{ borderRadius: '50%', marginRight: '8px' }} />
        <Skeleton width="40px" height="40px" style={{ borderRadius: '50%' }} />
      </div>
    </div>
  <div className={css.carouselWrapper} style={{ display: 'flex', gap: 'var(--carousel-gap)', overflowX: 'hidden' }}>
      {[...Array(4)].map((_, index) => (
        <div key={index} style={{ minWidth: '280px', flex: '0 0 auto' }}>
          <div style={{
            background: 'white',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}>
            <Skeleton width="100%" height="184px" style={{ borderRadius: '0' }} />
            <div style={{ padding: '16px' }}>
              <Skeleton width="80%" height="20px" style={{ marginBottom: '12px' }} />
              <Skeleton width="100%" height="14px" style={{ marginBottom: '8px' }} />
              <Skeleton width="60%" height="14px" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

// Category Section Skeleton
export const CategorySectionSkeleton = ({ sectionTitle }) => (
  <section className={css.disciplineSlider}>
    <div className={css.headerRow}>
      {sectionTitle ? (
        <h2 style={{ margin: '0 0 24px 0', fontSize: '20px', fontWeight: 'bold' }}>
          {sectionTitle}
        </h2>
      ) : (
        <Skeleton width="280px" height="28px" style={{ marginBottom: '24px' }} />
      )}
      <div className={css.carouselArrows}>
        <Skeleton width="40px" height="40px" style={{ borderRadius: '50%', marginRight: '8px' }} />
        <Skeleton width="40px" height="40px" style={{ borderRadius: '50%' }} />
      </div>
    </div>
  <div className={css.carouselWrapper} style={{ display: 'flex', gap: 'var(--carousel-gap)', overflowX: 'hidden' }}>
      {[...Array(4)].map((_, index) => (
        <div key={index} className={css.articleSlider} style={{ minWidth: '280px', flex: '0 0 auto' }}>
          <div className={css.articleImage}>
            <Skeleton width="100%" height="184px" style={{ borderRadius: '0' }} />
            <div className={css.articleTitle} style={{ 
              position: 'absolute', 
              bottom: '16px', 
              left: '16px', 
              right: '16px' 
            }}>
              <Skeleton width="120px" height="20px" style={{ backgroundColor: 'rgba(255,255,255,0.9)' }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

// Region Discipline Section Skeleton
export const RegionDisciplineSectionSkeleton = ({ sectionTitle }) => (
  <section className={css.disciplineSlider}>
    <div className={css.headerRow}>
      {sectionTitle ? (
        <h2 style={{ margin: '0 0 24px 0', fontSize: '20px', fontWeight: 'bold' }}>
          {sectionTitle}
        </h2>
      ) : (
        <Skeleton width="320px" height="28px" style={{ marginBottom: '24px' }} />
      )}
      <div className={css.carouselArrows}>
        <Skeleton width="40px" height="40px" style={{ borderRadius: '50%', marginRight: '8px' }} />
        <Skeleton width="40px" height="40px" style={{ borderRadius: '50%' }} />
      </div>
    </div>
  <div className={css.carouselWrapper} style={{ display: 'flex', gap: 'var(--carousel-gap)', overflowX: 'hidden' }}>
      {[...Array(4)].map((_, index) => (
        <div key={index} className={css.articleSlider} style={{ minWidth: '280px', flex: '0 0 auto' }}>
          <div className={css.articleImage}>
            <Skeleton width="100%" height="184px" style={{ borderRadius: '0' }} />
            <div className={css.articleTitle} style={{ 
              position: 'absolute', 
              bottom: '60px', 
              left: '16px', 
              right: '16px' 
            }}>
              <Skeleton width="150px" height="20px" style={{ backgroundColor: 'rgba(255,255,255,0.9)', marginBottom: '8px' }} />
            </div>
          </div>
          <div style={{ padding: '16px' }}>
            <Skeleton width="100%" height="14px" style={{ marginBottom: '8px' }} />
            <Skeleton width="100%" height="14px" style={{ marginBottom: '8px' }} />
            <Skeleton width="80%" height="14px" />
          </div>
        </div>
      ))}
    </div>
  </section>
);

// Article Section Skeleton
export const ArticleSectionSkeleton = ({ sectionTitle }) => (
  <section className={css.disciplineSlider}>
    <div className={css.headerRow}>
      {sectionTitle ? (
        <h2 style={{ margin: '0 0 24px 0', fontSize: '20px', fontWeight: 'bold' }}>
          {sectionTitle}
        </h2>
      ) : (
        <Skeleton width="200px" height="28px" style={{ marginBottom: '24px' }} />
      )}
      <div className={css.carouselArrows}>
        <Skeleton width="40px" height="40px" style={{ borderRadius: '50%', marginRight: '8px' }} />
        <Skeleton width="40px" height="40px" style={{ borderRadius: '50%' }} />
      </div>
    </div>
  <div className={css.carouselWrapper} style={{ display: 'flex', gap: 'var(--carousel-gap)', overflowX: 'hidden' }}>
      {[...Array(3)].map((_, index) => (
        <div key={index} style={{ minWidth: '320px', flex: '0 0 auto' }}>
          <div style={{
            background: 'white',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}>
            <Skeleton width="100%" height="200px" style={{ borderRadius: '0' }} />
            <div style={{ padding: '20px' }}>
              <Skeleton width="90%" height="22px" style={{ marginBottom: '12px' }} />
              <Skeleton width="100%" height="16px" style={{ marginBottom: '8px' }} />
              <Skeleton width="100%" height="16px" style={{ marginBottom: '8px' }} />
              <Skeleton width="100%" height="16px" style={{ marginBottom: '8px' }} />
              <Skeleton width="70%" height="16px" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

// Add shimmer animation CSS
const shimmerCSS = `
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

// Inject CSS if not already present (only in browser)
if (typeof document !== 'undefined' && !document.getElementById('skeleton-shimmer-styles')) {
  const style = document.createElement('style');
  style.id = 'skeleton-shimmer-styles';
  style.textContent = shimmerCSS;
  document.head.appendChild(style);
}
